export interface GetCollectionListDetailRequest {
  id: number
}

export function GetCollectionListDetailRequestToJSON(
  value: GetCollectionListDetailRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
